export { default } from './CouponsService';



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/coupons/services/index.js